/* ============================================================
   PST Pool PDP — "SUNRAY TRACK" kit-builder stepper.
   Progressive enhancement: without JS every step panel shows (scroll).
   With JS only the current step is visible, with a water-fill progress
   rail of icon tiles (clickable to jump/edit any step), Back/Next, a
   one-shot completion pop, and a mobile scroll rail. Steps = every
   [data-pst-step-panel] inside a [data-pst-stepper]. Each panel carries
   data-step-icon + data-step-short; title/tag are read from its header.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ICONS = {
    waves: '<path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>',
    filter: '<path d="M22 3H2l8 9.5V19l4 2v-8.5L22 3Z"/>',
    ladder: '<path d="M7 2v20M17 2v20M7 7h10M7 12h10M7 17h10"/>',
    droplets: '<path d="M7 16.3a4 4 0 0 0 6 0c2-2.3 1-5.3-3-9.3-4 4-5 7-3 9.3Z"/><path d="M16.7 11a3 3 0 0 0 4.3 0c1.4-1.6.7-3.7-2.1-6.5-2.8 2.8-3.5 4.9-2.2 6.5Z"/>',
    shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/>',
    sparkles: '<path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3Z"/><path d="M19 14l.9 2.1L22 17l-2.1.9L19 20l-.9-2.1L16 17l2.1-.9L19 14Z"/>',
    snowflake: '<path d="M12 2v20M4 7l16 10M20 7 4 17"/>',
    lightbulb: '<path d="M9 18h6M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.8c.6.4 1 1.2 1 2v.2h6v-.2c0-.8.4-1.6 1-2A7 7 0 0 0 12 2Z"/>',
    box: '<path d="M21 8 12 3 3 8v8l9 5 9-5V8Z"/><path d="m3 8 9 5 9-5M12 13v8"/>'
  };
  function icon(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || ICONS.box) + '</svg>';
  }
  var CHECK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var A_L = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  var A_R = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var CART = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.4 12.2a1.7 1.7 0 0 0 1.7 1.4h8.3a1.7 1.7 0 0 0 1.7-1.3L23 7H6"/></svg>';

  function tagKey(t) { t = (t || '').toLowerCase(); return (t === 'required' || t === 'recommended' || t === 'optional') ? t : 'optional'; }
  var ABBR = { required: 'Req', recommended: 'Rec', optional: 'Opt' };
  function esc(s) { return (s || '').replace(/"/g, ''); }
  function headerOffset() {
    var px = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
    return (isNaN(px) ? 80 : px) + 18;
  }

  function Stepper(root) {
    this.root = root;
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-pst-step-panel]'));
    this.prog = root.querySelector('[data-stepper-progress]');
    this.foot = root.querySelector('[data-stepper-nav]');
    if (this.panels.length < 1 || !this.prog || !this.foot) { return; }
    this.steps = this.panels.map(function (p) {
      var t = p.querySelector('.pst-panel__step-title');
      var g = p.querySelector('.pst-step-tag');
      var title = t ? t.textContent.trim() : 'Step';
      return {
        title: title,
        tag: g ? g.textContent.trim() : '',
        icon: p.getAttribute('data-step-icon') || 'box',
        short: p.getAttribute('data-step-short') || title
      };
    });
    this.current = 0;
    this.done = {};
    this.build();
    this.prog.hidden = false;
    this.foot.hidden = false;
    this.bind();
    this.render(true);
  }

  Stepper.prototype.build = function () {
    this.prog.classList.add('pst-track');
    this.prog.setAttribute('role', 'group');
    this.prog.setAttribute('aria-label', 'Build your pool kit — step progress');
    var nodes = this.steps.map(function (s, i) {
      var tk = tagKey(s.tag);
      return '<li class="pst-track__node" data-state="upcoming">'
        + '<button type="button" class="pst-track__btn" data-goto="' + i + '">'
        + '<span class="pst-track__icon">' + icon(s.icon) + '</span>'
        + '<span class="pst-track__check" aria-hidden="true">' + CHECK + '</span></button>'
        + '<span class="pst-track__label"><span class="pst-track__name">' + s.short + '</span>'
        + '<span class="pst-track__req pst-track__req--' + tk + '" title="' + s.tag + '">' + (ABBR[tk] || s.tag) + '</span></span>'
        + '</li>';
    }).join('');
    this.prog.innerHTML =
      '<div class="pst-track__head">'
      + '<span class="pst-track__count">Step <b data-tk-count>1</b> of ' + this.steps.length + '</span>'
      + '<span class="pst-track__sep" aria-hidden="true">·</span>'
      + '<span class="pst-track__now" data-tk-now></span>'
      + '<span class="pst-track__tag" data-tk-tag></span></div>'
      + '<div class="pst-track__rail-wrap"><span class="pst-track__rail" aria-hidden="true"></span>'
      + '<span class="pst-track__fill" aria-hidden="true" style="--progress:0%"></span>'
      + '<ol class="pst-track__nodes">' + nodes + '</ol></div>';

    this.foot.classList.add('pst-track__foot');
    this.foot.innerHTML =
      '<button type="button" class="pst-track__back" data-prev>' + A_L + ' Back</button>'
      + '<span class="pst-track__foot-mini" data-tk-mini></span>'
      + '<button type="button" class="pst-track__next" data-next></button>';
  };

  Stepper.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var g = e.target.closest('[data-goto]');
      if (g) { self.go(parseInt(g.getAttribute('data-goto'), 10)); return; }
      if (e.target.closest('[data-prev]')) { self.go(self.current - 1); return; }
      var nx = e.target.closest('[data-next]');
      if (nx) {
        if (nx.classList.contains('is-finish')) {
          var add = document.querySelector('[data-pst-addkit]');
          if (add) { add.click(); }
        } else { self.go(self.current + 1); }
        return;
      }
    });
  };

  Stepper.prototype.go = function (i) {
    if (i < 0 || i >= this.steps.length || i === this.current) { return; }
    this.current = i;
    this.render(false);
    var y = this.root.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  };

  Stepper.prototype.render = function (first) {
    var self = this, cur = this.current, total = this.steps.length;
    this.panels.forEach(function (p, i) { p.hidden = i !== cur; });

    var lis = this.prog.querySelectorAll('.pst-track__node');
    Array.prototype.forEach.call(lis, function (li, i) {
      var state = i < cur ? 'done' : (i === cur ? 'active' : 'upcoming');
      li.setAttribute('data-state', state);
      var btn = li.querySelector('.pst-track__btn');
      var s = self.steps[i];
      if (state === 'done') {
        btn.removeAttribute('aria-current');
        btn.setAttribute('aria-label', 'Step ' + (i + 1) + ': ' + esc(s.title) + ', completed. Edit.');
        if (!self.done[i] && !first && !reduce) {
          li.classList.add('just-completed');
          (function (el) { setTimeout(function () { el.classList.remove('just-completed'); }, 640); })(li);
        }
        self.done[i] = true;
      } else if (state === 'active') {
        btn.setAttribute('aria-current', 'step');
        btn.setAttribute('aria-label', 'Step ' + (i + 1) + ': ' + esc(s.title) + ', current step.');
        self.done[i] = false;
      } else {
        btn.removeAttribute('aria-current');
        btn.setAttribute('aria-label', 'Step ' + (i + 1) + ': ' + esc(s.title) + ', ' + (s.tag || '').toLowerCase() + ', not started. Jump to step.');
        self.done[i] = false;
      }
    });

    var pct = total > 1 ? (cur / (total - 1)) * 100 : 0;
    this.prog.querySelector('.pst-track__fill').style.setProperty('--progress', pct + '%');

    var s = this.steps[cur];
    this.prog.querySelector('[data-tk-count]').textContent = (cur + 1);
    this.prog.querySelector('[data-tk-now]').textContent = s.title;
    var tag = this.prog.querySelector('[data-tk-tag]');
    tag.textContent = s.tag;
    tag.className = 'pst-track__tag pst-track__tag--' + tagKey(s.tag);

    this.foot.querySelector('[data-tk-mini]').textContent =
      'Step ' + (cur + 1) + ' of ' + total + ' · ' + s.title + (s.tag ? ' · ' + s.tag : '');
    var back = this.foot.querySelector('[data-prev]');
    var next = this.foot.querySelector('[data-next]');
    back.disabled = cur === 0;
    if (cur === total - 1) {
      next.classList.add('is-finish');
      next.innerHTML = CART + ' Add to cart';
    } else {
      next.classList.remove('is-finish');
      next.innerHTML = 'Next: ' + this.steps[cur + 1].short + ' ' + A_R;
    }

    if (!first && window.innerWidth <= 540) {
      var an = lis[cur];
      if (an && an.scrollIntoView) { an.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }
    }
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pst-stepper]'), function (r) {
      if (!r._pstStepper) { r._pstStepper = new Stepper(r); }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
